import React from 'react';
import { setSolvedStand } from '../../../api/api.js';

const Standard = ({id, stand, setStand, expStand, setExpStand, randomPrefTo, randomUnit, standardSolution, standardExpSolution, checkStand}) => {
    const checkAnswer = () => {
        const solved = parseFloat(fixDot(stand)) === standardSolution && parseInt(expStand) === standardExpSolution;
        if (solved) {
            setSolvedStand(id)
        }
        console.log('SOLVED_STANDARD', solved);

        return solved;
    };

    const fixDot = (str) => str.replace(',','.');

    return (
        <td className={ checkStand ? checkAnswer() ? 'true-answer' : 'false-answer' : undefined }>
            <div className="notation left standard num">
                <input disabled={checkStand ? 'disabled' : undefined } className="inputStandard" type="text" value={stand} onChange={e => setStand(e.target.value)} />
            </div>
            <div className="notation right">
                <div className="exponent">&nbsp;· 10 <sup><input disabled={checkStand ? 'disabled' : undefined } className="inputExp" type="text" value={expStand} onChange={e => setExpStand(e.target.value)} /></sup></div>
                &nbsp;
                <div className="unit">{randomPrefTo.letter}{randomUnit.letter}</div>
            </div>
        </td>
    )
}

export default Standard;
